import type { FeedbackSummary } from '@/types/api'
import { Button } from './button'
import { Frown, Meh, Smile } from 'lucide-react'

interface FeedbackSummaryBarProps {
  data: FeedbackSummary
  selectedScores: number[]
  onToggleScore: (score: number) => void
}

export const SCORE_COLOR: Partial<Record<number, string>> = {
  2: 'text-[#FF383C]',
  3: 'text-[#CE7A58]',
  4: 'text-[#6155F5]',
}

export const getSatisfactionIcon = (score: number) => {
  switch (score) {
    case 4:
      return <Smile className="h-4 w-4 text-[#6155F5]" />
    case 3:
      return <Meh className="h-4 w-4 text-[#CE7A58]" />
    case 2:
      return <Frown className="h-4 w-4 text-[#FF383C]" />
  }
}
export function FeedbackSummaryBar({
  data,
  selectedScores,
  onToggleScore,
}: FeedbackSummaryBarProps) {
  const sorted = [...data.counts].sort((a, b) => b.score - a.score)
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
      {sorted.map((item) => {
        const isSelected = selectedScores.includes(item.score)
        return (
          <Button
            key={item.score}
            variant={isSelected ? 'outline' : 'ghost'}
            onClick={() => onToggleScore(item.score)}
            className={
              (SCORE_COLOR[item.score] ?? 'text-gray-700') +
              (isSelected ? ' border border-[#c45c30]' : '') +
              ' inline-flex items-center gap-1 rounded-md px-2 py-0.5 transition-colors hover:bg-gray-100/60 '
            }
            aria-pressed={isSelected}
          >
            {getSatisfactionIcon(item.score)}
            <span className="font-medium">{item.name}:</span>
            <span className="font-semibold ">{item.count}</span>
          </Button>
        )
      })}
    </div>
  )
}
